import { render } from "./Methodology.vue?vue&type=template&id=57c1b5c4&scoped=true"
import script from "./Methodology.vue?vue&type=script&lang=js"
export * from "./Methodology.vue?vue&type=script&lang=js"

import "./Methodology.vue?vue&type=style&index=0&id=57c1b5c4&scoped=true&lang=css"

import exportComponent from "/Users/elenejikia/Desktop/Parsons/Studio2/major-studio-2-sp24-1/06-vue-scrollytelling/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c1b5c4"]])

export default __exports__